import { render, staticRenderFns } from "./mainStatistics.vue?vue&type=template&id=0e6b4c1c&"
import script from "./mainStatistics.vue?vue&type=script&lang=js&"
export * from "./mainStatistics.vue?vue&type=script&lang=js&"
import style0 from "./mainStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports